export default "__VITE_ASSET__cxaSsvMa__"